// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-exports-banner-notifications-banner-notification-styles__banner-notification--animate-in {
  animation: src-exports-banner-notifications-banner-notification-styles__bannerNotificationSlideIn 400ms ease;
}

.src-exports-banner-notifications-banner-notification-styles__banner-notification--animate-out {
  animation: src-exports-banner-notifications-banner-notification-styles__bannerNotificationSlideOut 400ms ease forwards;
}

@keyframes src-exports-banner-notifications-banner-notification-styles__bannerNotificationSlideIn {
  0% {
    opacity: 0;
    transform: translateX(100%) scale(0.92);
  }

  100% {
    opacity: 1;
    transform: translateX(0%) scale(1);
  }
}

@keyframes src-exports-banner-notifications-banner-notification-styles__bannerNotificationSlideOut {
  0% {
    opacity: 1;
    transform: translateX(0%) scale(1);
  }

  99% {
    opacity: 0;
  }

  100% {
    display: none;
    opacity: 0;
    transform: translateX(100%) scale(0.92);
  }
}
`, "",{"version":3,"sources":["webpack://./src/exports/banner-notifications/banner-notification.styles.css"],"names":[],"mappings":"AAAA;EACE,4GAA+C;AACjD;;AAEA;EACE,sHAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,UAAU;IACV,uCAAuC;EACzC;AACF","sourcesContent":[".banner-notification--animate-in {\n  animation: bannerNotificationSlideIn 400ms ease;\n}\n\n.banner-notification--animate-out {\n  animation: bannerNotificationSlideOut 400ms ease forwards;\n}\n\n@keyframes bannerNotificationSlideIn {\n  0% {\n    opacity: 0;\n    transform: translateX(100%) scale(0.92);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0%) scale(1);\n  }\n}\n\n@keyframes bannerNotificationSlideOut {\n  0% {\n    opacity: 1;\n    transform: translateX(0%) scale(1);\n  }\n\n  99% {\n    opacity: 0;\n  }\n\n  100% {\n    display: none;\n    opacity: 0;\n    transform: translateX(100%) scale(0.92);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner-notification--animate-in": `src-exports-banner-notifications-banner-notification-styles__banner-notification--animate-in`,
	"bannerNotificationSlideIn": `src-exports-banner-notifications-banner-notification-styles__bannerNotificationSlideIn`,
	"banner-notification--animate-out": `src-exports-banner-notifications-banner-notification-styles__banner-notification--animate-out`,
	"bannerNotificationSlideOut": `src-exports-banner-notifications-banner-notification-styles__bannerNotificationSlideOut`
};
export default ___CSS_LOADER_EXPORT___;
